import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';

export const removePartsFromSelection =
  (keysToRemove: Set<go.Key>) => (diagram: Diagram) => {
    const newSelection = diagram.selection.filter(
      (part) => !part.key || !keysToRemove.has(part.key)
    );

    if (diagram.selection.count !== newSelection.count) {
      setDiagramSelection(newSelection)(diagram);
    }
  };
